import { QueryClient } from 'react-query';
const PRODUCTION_CONFIG = {
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            cacheTime: 1000 * 60 * 10,
            refetchOnWindowFocus: false,
            retry: 2
        }
    }
};
export function createQueryClient(config = PRODUCTION_CONFIG) {
    return new QueryClient(config);
}
export const queryClient = createQueryClient();
//# sourceMappingURL=queryClient.js.map